import { useEffect } from 'react';
import { useConditionMonitorJob } from '@/vantage/components/evidence_table/useConditionMonitorJob.hook';
import { useEvidenceConditionMonitor } from '@/vantage/components/evidence_table/useEvidenceConditionMonitor.hook';
import {
  useConditionMonitorLastFinishedRunId,
  useEvidenceTableDefinition,
  useVantageWorkbookActions,
} from '@/vantage/vantageWorkbook.store';

export const VantageStoppedConditionMonitorStateSync = () => {
  const conditionMonitorId = useEvidenceTableDefinition()?.subscription?.id;
  const lastFinishedRunId = useConditionMonitorLastFinishedRunId();
  const conditionMonitor = useEvidenceConditionMonitor(conditionMonitorId, lastFinishedRunId);
  const conditionMonitorJob = useConditionMonitorJob(conditionMonitorId, lastFinishedRunId);
  const { setStoppedConditionMonitorState } = useVantageWorkbookActions();

  useEffect(() => {
    if (!conditionMonitor?.id) {
      return;
    }
    const isConfigured = conditionMonitor.firstRunLookBack != null;
    if (conditionMonitor.isArchived || (isConfigured && (!conditionMonitor.enabled || conditionMonitorJob === null))) {
      setStoppedConditionMonitorState({
        id: conditionMonitor.id,
        isEnabled: conditionMonitor.enabled,
        isArchived: conditionMonitor.isArchived ?? false,
        permissions: conditionMonitor.effectivePermissions,
        conditionMonitorJobId: conditionMonitorJob?.id,
      });
    } else {
      setStoppedConditionMonitorState(undefined);
    }
  }, [conditionMonitor, conditionMonitorJob]);

  return null;
};
